export const PROFILE_LANGUAGES = ["ja", "zh", "ar", "ko"] as const;

export type ProfileLanguage = (typeof PROFILE_LANGUAGES)[number];

export const PROFILE_LANGUAGE_LABEL_KEYS: Record<ProfileLanguage, string> = {
  ja: "profileLanguages.ja",
  zh: "profileLanguages.zh",
  ar: "profileLanguages.ar",
  ko: "profileLanguages.ko",
};
